// A read-only value with a copy button — for invite/reset links the admin hands
// to a user. Uses the async clipboard API with a brief "Copied" confirmation.

import { useState } from "react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function CopyField({ value, label }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Couldn't copy — select and copy manually");
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Input readOnly value={value} aria-label={label ?? "Link"} className="font-mono text-xs" />
      <Button variant="outline" size="icon" aria-label="Copy" onClick={() => void copy()}>
        {copied ? <IconCheck className="text-emerald-500" /> : <IconCopy />}
      </Button>
    </div>
  );
}
